import { useAtom, useAtomValue } from 'jotai';
import cn from 'classnames';
import Image from 'next/image';

import { toBase64 } from '../../../../utils/toBase64';
import {
  currentPageAtom,
  isFirstPageImageLoadedAtom,
  zoomLevelAtom,
} from '../../../../store/index.atom';
import PdfPageImage from '../../PdfPageImage';
import { ViewerPageImageItem } from '../index.types';

import * as Styled from './index.styles';

interface Props {
  thumnails: (ViewerPageImageItem | null)[] | null | undefined;
  isMobileLandscape: boolean;
}

const MobilePage = ({ thumnails, isMobileLandscape }: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const zoomLevel = useAtomValue(zoomLevelAtom);

  /* 첫 번째 이미지가 렌더링 된 이후에, 이후의 페이지들을 렌더링한다 */
  const [isFirstPageImageLoaded, setIsFirstPageImageLoaded] = useAtom(
    isFirstPageImageLoadedAtom,
  );

  const firstItem = thumnails?.[0];

  return (
    <>
      {isFirstPageImageLoaded ? (
        thumnails?.map(
          (item, index) =>
            item?.src && (
              <Styled.ImageWrapper
                className={cn({
                  visible: currentPage === index + 1,
                  hidden: currentPage !== index + 1,
                  disabledScrollY: !isMobileLandscape,
                })}
                key={item.src}
                onContextMenu={(e) => e.preventDefault()}
              >
                {item.imageSources ? (
                  <PdfPageImage
                    viewer={item.imageSources.viewer}
                    alt={`pdf${currentPage}page`}
                    sizes="100vw"
                  />
                ) : (
                  <Image
                    key={zoomLevel}
                    src={item.src}
                    alt={`pdf${currentPage}page`}
                    layout="fill"
                    objectFit="contain"
                    priority
                    placeholder="blur"
                    blurDataURL={`data:image/svg+xml;base64,${toBase64(
                      item.src,
                    )}`}
                    draggable={false}
                    style={{
                      userSelect: 'none',
                    }}
                    sizes="100vw"
                  />
                )}
              </Styled.ImageWrapper>
            ),
        )
      ) : (
        <Styled.ImageWrapper
          className={cn({
            visible: currentPage === 1,
            hidden: currentPage !== 1,
            disabledScrollY: !isMobileLandscape,
          })}
          onContextMenu={(e) => e.preventDefault()}
        >
          {firstItem?.src &&
            (firstItem.imageSources ? (
              <PdfPageImage
                viewer={firstItem.imageSources.viewer}
                alt={`pdf${currentPage}page`}
                sizes="100vw"
                onLoad={() => {
                  setIsFirstPageImageLoaded(true);
                }}
              />
            ) : (
              <Image
                key={zoomLevel}
                src={firstItem.src}
                alt={`pdf${currentPage}page`}
                layout="fill"
                objectFit="contain"
                placeholder="blur"
                blurDataURL={`data:image/svg+xml;base64,${toBase64(
                  firstItem.src,
                )}`}
                priority
                onLoadingComplete={() => {
                  setIsFirstPageImageLoaded(true);
                }}
                style={{
                  userSelect: 'none',
                }}
                sizes="100vw"
              />
            ))}
        </Styled.ImageWrapper>
      )}
    </>
  );
};

export default MobilePage;
